module.exports = __webpack_public_path__ + "img/icone-leaf.648b85ba.svg";